import React, { Component } from "react";

import { ReactComponent as Development } from "../../assets/images/home/development.svg";
import { ReactComponent as PaintBrushGirl } from "../../assets/images/home/paintbrush.svg";
import { ReactComponent as Educational } from "../../assets/images/home/educational.svg";

import Card from "../Card";

class ServicesPage extends Component {
  state = {
    isFliped: false,
  };

  onFlipHandler = (clickedCard) => {
    const developmentCard = document.querySelector(".development-card");
    const designCard = document.querySelector(".design-card");

    if (clickedCard === "devCard") {
      developmentCard.classList.toggle("flip");
    } else if (clickedCard === "designCard") {
      designCard.classList.toggle("flip");
    }
  };

  render() {
    return (
      <section className="main-services" id="services">
        <div className="content-wrapper">
          <div className="main-headline">
            <h1 className="headline">
              Our <br />
              Services
            </h1>
          </div>

          <div className="services-container fade-in">
            <Card
              cardHeader="Consulting"
              cardImg={<Educational />}
              sideParagraphs={[
                {
                  title: "Technical Skills",
                  description:
                    "We help our clients achieve a higher level of technical and organisational skills.",
                },
                {
                  title: "Automation",
                  description:
                    "We help companies develop and implement automation strategies to improve efficiency and reduce costs.",
                },
                {
                  title: "AI Integration",
                  description:
                    "We help companies integrate AI into their business processes to improve decision-making and drive innovation.",
                },
              ]}
              linkButtonProps={{ link: "/contacts", text: "Need a Teacher?" }}
            />
            <Card
              cardHeader="Development"
              cardImg={<Development />}
              sideParagraphs={[
                {
                  title: "Web Development",
                  description:
                    "We provide full-stack development with AI integrations for innovative solutions to your needs.",
                },
                {
                  title: "Hybrid Apps Development",
                  description:
                    "Effective solutions for iOS and Android platforms with focus on performance.",
                },
                {
                  title: "Project Management",
                  description:
                    "Quality-driven project management to ensure timely delivery and high standards.",
                },
              ]}
              linkButtonProps={{ link: "/contacts", text: "Need a Developer?" }}
            />
            <Card
              cardHeader="Design"
              cardImg={<PaintBrushGirl />}
              sideParagraphs={[
                {
                  title: "Websites Design",
                  description:
                    "We create comprehensive and sophisticated yet simple to use interfaces for your web app.",
                },
                {
                  title: "Conversion Rate Optimization",
                  description:
                    "We analyze your website and provide recommendations to improve user experience and increase conversions.",
                },
                {
                  title: "UX/UI Design",
                  description:
                    "We design the flow of a multi-screen app, interactions and animations, to make interface feel amazing.",
                },
              ]}
              linkButtonProps={{ link: "/contacts", text: "Need a Designer?" }}
            />
          </div>
        </div>
      </section>
    );
  }
}
export default ServicesPage;
